import { render, staticRenderFns } from "./ProviderAside.vue?vue&type=template&id=5763e747&"
import script from "./ProviderAside.vue?vue&type=script&lang=js&"
export * from "./ProviderAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports